import TableContainer from 'components/Common/TableContainer'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Card, CardBody, Col, Container, Input, Label, Row, Modal, ModalBody, ModalHeader, Form, FormGroup, FormFeedback, UncontrolledTooltip } from 'reactstrap'
import {
    getStateStart,
    getRegStart
} from "store/Policy/action"
import { SrNo, Design, DesignName, DesignDescription } from './MarketingCol'
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
//import ManageRtoReducer from 'store/SuperAdmin/ManageRTO/Reducer'
import Spinners from 'components/Common/Spinner'
import { createSelector } from 'reselect'
import { deleteDesign, getDesigns, uploadDesign } from 'store/actions'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'
import SavedDesign from './SavedDesign'

const ManageMarketingTools = () => {

    const dispatch = useDispatch();

    const [modal, setModal] = useState({
        isShow: false,
    })

    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [selectedDesignId, setSelectedDesignId] = useState(null)

    const [selectedDesign, setSelectedDesign] = useState(null)

    const handleClickDelete = (desingID) =>{
        setShowDeleteModal(true)
        setSelectedDesignId(desingID)
    }

    const handleDeleteDesign = () =>{
        dispatch(deleteDesign({id: selectedDesignId}))
        setShowDeleteModal(false)
    }

    const ManageRtoReducer = state => state.ManageMarketingToolsReducer
    const ManageRtoReducerProperty = createSelector(
        ManageRtoReducer,
        ManageRtoStore => ({
            errors: ManageRtoStore.errors,
            successMsg: ManageRtoStore.successMsg,
            Loading: ManageRtoStore.Loading,
            designList: ManageRtoStore.designList
        })
    )


    const { errors, successMsg, Loading, designList } =
        useSelector(ManageRtoReducerProperty)

    const columns = useMemo(
        () => [
            {
                Header: "Sr No",
                accessor: (row, i) => i + 1,
                filterable: true,
                Cell: cellProps => {
                    return <SrNo {...cellProps} />
                },
            },
            {
                Header: "Design",
                accessor: "design",
                filterable: true,
                Cell: cellProps => {
                    return <SavedDesign canvasData={cellProps.row.original.design} /> || ""
                },
            },
            {
                Header: "Design Name",
                accessor: "design_name",
                filterable: true,
                Cell: cellProps => {
                    return <DesignName {...cellProps} />
                },
            },

            {
                Header: "Design Description",
                accessor: "description",
                filterable: true,
                Cell: cellProps => {
                    return <DesignDescription {...cellProps} />
                },
            },
            {
                Header: "Action",
                accessor: "performAction",
                disableFilters: true,
                Cell: cellProps => {
                    return (
                            <ul className="list-unstyled hstack gap-2 mb-0">

                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-danger"
                                         onClick={() => handleClickDelete(cellProps.row.original.id)
                                         }
                                        id={`deletetooltip-${cellProps.row.original.id}`}
                                    >
                                        <i className="mdi mdi-delete-outline fs-5" />
                                        <UncontrolledTooltip
                                            placement="top"
                                            target={`deletetooltip-${cellProps.row.original.id}`}
                                        >
                                            Delete Design
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>


                            </ul>)
                      
                },
            },

        ])

    const validation = useFormik({
        // enableReinitialize : use this  flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            design_name: "" || "",
            description: "" || "",
        },
        validationSchema: Yup.object({
            design_name: Yup.string().required("Please Select State"),
            description: Yup.string().required("Please Enter Registration Number"),
        }),
        onSubmit: values => {
            dispatch(uploadDesign({ ...values, design: selectedDesign }))
            handleCloseModal();
        },
    })

    const handleCloseModal = () => {
        setModal({ ...modal, isShow: false })
    }

    useEffect(() => {
        if (errors && errors !== "") {
            toast.error(errors)
        }
        if (successMsg && successMsg !== "") {
            toast.success(successMsg)
            dispatch(getDesigns())
        }
    }, [errors, successMsg])

    useEffect(() => {
        dispatch(getDesigns())
    }, [])


    return (
        <div className='page-content'>
            <Container fluid={true}>
                
                   

                        <Card>
                            <div className='m-3 d-flex align-items-center justify-content-between'>
                                <h4>Manage Marketing Tools</h4>
                                <Link to={'/super/admin/marketing-tools/create-designs'} className='btn btn-primary'>
                                    Create Designs
                                </Link>
                            </div>

                            <CardBody>

                           { Loading ? <Spinners /> :
                                <div className='mt-5'>


                                    <TableContainer
                                        columns={columns}
                                        data={designList}
                                        isGlobalFilter={true}
                                        isAddOptions={false}
                                        isJobListGlobalFilter={false}
                                        isPagination={true}
                                        iscustomPageSizeOptions={true}
                                        isShowingPageLength={true}
                                        customPageSize={15}
                                        tableClass="table-bordered align-middle nowrap mt-2"
                                        paginationDiv="col-sm-12 col-md-7"
                                        pagination="pagination justify-content-end pagination-rounded"
                                    />
                                </div>}
                            </CardBody>
                        </Card>
            </Container>


            <Modal isOpen={modal.isShow} toggle={handleCloseModal}>
                <ModalHeader toggle={handleCloseModal} tag={"h4"}>
                    <p>Are You Sure ?</p>
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}>
                        <FormGroup>
                            <Label for={'designInput'}>Enter Design Name</Label>
                            <Input
                                type='text'
                                name='design_name'
                                id='designInput'
                                placeholder="Enter Design Name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                    validation.touched.design_name &&
                                        validation.errors.design_name
                                        ? true
                                        : false
                                }
                            >

                            </Input>
                            {validation.touched.design_name &&
                                validation.errors.design_name ? (
                                <FormFeedback type="invalid">
                                    {validation.errors.design_name}
                                </FormFeedback>
                            ) : null}

                        </FormGroup>

                        <FormGroup>
                            <Label for='descriptionInput'>Enter Description</Label>
                            <Input
                                name='description'
                                id='descriptionInput'
                                placeholder="Enter description"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                    validation.touched.description &&
                                        validation.errors.description
                                        ? true
                                        : false
                                }
                            />

                            {validation.touched.description &&
                                validation.errors.description ? (
                                <FormFeedback type="invalid">
                                    {validation.errors.description}
                                </FormFeedback>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for='designInput'>Choose Design</Label>
                            <Input
                                type='file'
                                name='design'
                                id='designInput'
                                placeholder="Enter RTO"
                                accept="image/png, image/gif, image/jpeg"
                                onChange={(e) => setSelectedDesign(e.target.files[0])}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Button color='primary' type='submit'>Submit</Button>
                        </FormGroup>

                    </Form>
                </ModalBody>
            </Modal>


            <Modal isOpen={showDeleteModal} toggle={()=>setShowDeleteModal(!showDeleteModal)}>
                <ModalHeader toggle={()=>setShowDeleteModal(!showDeleteModal)} tag={"h4"}>
                    <p>Are You Sure ?</p>
                </ModalHeader>
                <ModalBody>
                    <p className='fs-3'>{"Do you want Delete Design"}</p>
                    <div className='d-flex justify-content-between'>

                        <Button color='danger' onClick={handleDeleteDesign}>DELETE</Button>
                        <Button color='primary' onClick={()=>setShowDeleteModal(false)}>CANCEL</Button>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default ManageMarketingTools